// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoCarousel_root__GmYX6","imageWrapper":"LogoCarousel_imageWrapper__aZc86","image":"LogoCarousel_image__zn2Lj"};